import { render, staticRenderFns } from "./detailsRemarks.vue?vue&type=template&id=5c4d6c09&scoped=true&"
import script from "./detailsRemarks.vue?vue&type=script&lang=js&"
export * from "./detailsRemarks.vue?vue&type=script&lang=js&"
import style0 from "./detailsRemarks.vue?vue&type=style&index=0&id=5c4d6c09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d6c09",
  null
  
)

export default component.exports